"use strict";

App.FireNotice = class FireNotice
	{
	get config()
		{
		return {
			apiKey: "AIzaSyBTfY4ba2wzkQUJHR2zGLRfiHytJNH_pgk",
			authDomain: "stele-1d504.firebaseapp.com",
			databaseURL: "https://stele-1d504.firebaseio.com",
			projectId: "stele-1d504",
			storageBucket: "stele-1d504.appspot.com",
			messagingSenderId: "179589314971",
			appId: "1:179589314971:web:1ea9d58e8c8a65fc51493e"
		};

		}

	constructor()
		{
		try
			{
			if (window.PushNotification !== undefined)
				{
				this.pushPlugin = PushNotification.init({
					android: {
						senderID: "179589314971",
						sound: true,
						vibrate: true
					},
					ios: {
						"senderID": "179589314971",
						// "gcmSandbox": "true",
						// "fcmSandbox": "true",
						"alert": "true",
						"badge": "true",
						"sound": "true"
					},
					windows: {}
				});

				this.askSubscribe();

				this.pushPlugin.on('notification', (data) => {
					console.log("notice:", data);
				});

				push.on('error', (e) => {
					console.log(e);
				});

				// this.pushPlugin.on('error', function (e) {
				// 	_this.$Message.info(
				// 		{
				// 			content: e.message,
				// 			duration: 0,
				// 			closable: true
				// 		});
				// });
				}

			// window.push.on('registration', function (data) {
			// 	_this.$store.dispatch('setState', {fcm: data.registrationId})
			// })
			//
			//


			if ('Notification' in window)
				{
				if (firebase.apps.length === 0)
					{
					firebase.initializeApp(this.config);
					}
				this.messaging = firebase.messaging();

				// if (Notification.permission === 'granted')
				{
				this.askSubscribe();
				}

				// $('#subscribe').on('click', function () {
				// 	subscribe();
				// });
				}


			}
		catch (e)
			{

			}
		}

	askSubscribe()
		{
		try
			{
			if (this.messaging !== undefined)
				{
				this.messaging.requestPermission()
					.then(this.subscribe.bind(this))
					.catch(function (err) {
						console.warn('Не удалось получить разрешение на показ уведомлений.', err);
					});
				}
			if (this.pushPlugin !== undefined)
				{
				PushNotification.hasPermission((data) => {
					console.log('data');
					this.pushPlugin.on('registration', (data) => {
						this.saveToken(data.registrationId);
					});
				});

				}
			}
		catch (e)
			{

			}

		}

	subscribe()
		{
		try
			{
			this.messaging.getToken()
				.then(this.saveToken.bind(this))
				.catch(function (err) {
					console.warn('При получении токена произошла ошибка.', err);
					this.setTokenSentToServer(false);
				});
			}
		catch (e)
			{

			}



		}

	saveToken(currentToken)
		{
		console.log(currentToken);
		if (currentToken)
			{
			this.sendTokenToServer(currentToken);
			}
		else
			{
			console.warn('Не удалось получить токен.');
			// this.setTokenSentToServer(false);
			}
		}

	sendTokenToServer(currentToken)
		{
		// if (!this.isTokenSentToServer(currentToken))
		// 	{
		console.log('Отправка токена на сервер...');
		app.ajax('/auth/save-token', {firebase_token: currentToken}, this.saveSuccess.bind(this));
		// 	}
		// else
		// 	{
		// 	console.log('Токен уже отправлен на сервер.');
		// 	}
		}

	saveSuccess(response)
		{
		if (response.status === 'OK')
			{
			console.log('Вы успешно подписались на уведомления');
			// app.addNotice('Вы успешно подписались на уведомления');
			// this.setTokenSentToServer(currentToken);
			}
		}

	// setTokenSentToServer(currentToken)
	// 	{
	// 	window.localStorage.setItem(
	// 		'sentFirebaseMessagingToken',
	// 		currentToken ? currentToken : ''
	// 	);
	// 	}
	//
	// isTokenSentToServer(currentToken)
	// 	{
	// 	return window.localStorage.getItem('sentFirebaseMessagingToken') == currentToken;
	// 	}

	};

